import { ClipboardList } from "lucide-react";
import ApqpDashboardSection from "@/components/ApqpDashboardSection";

export default function ApqpProjects() {
  return (
    <div className="p-6 lg:p-8 max-w-7xl mx-auto" data-testid="apqp-projects-page">
      <div className="flex items-center gap-2 mb-4">
        <ClipboardList size={22} className="text-orange-600" />
        <div>
          <h1 className="text-2xl font-bold text-slate-900">APQP Projects</h1>
          <p className="text-sm text-slate-500 mt-0.5">
            Won projects &amp; costings tracked as phase-grouped APQP plans. Click a project to open its APQP plan.
          </p>
        </div>
      </div>
      <ApqpDashboardSection />
    </div>
  );
}
